import React from 'react';

import { EmployeeDirectoryImportWizardMatchingContactsBase } from '../util/employee-directory-import-wizard-matching-contacts-base';

type Props = EmployeeDirectoryWizardStepProps;

export const EmployeeDirectoryImportWizardContactMatchingContacts = ({
  employeeDirectoryImportId,
  onNext,
  onCancel,
  PageIndicator,
}: Props) => (
  <EmployeeDirectoryImportWizardMatchingContactsBase
    employeeDirectoryImportId={employeeDirectoryImportId}
    onNext={onNext}
    onCancel={onCancel}
    pathSegment="contact-matching-contacts"
    title="Contact Information Matching People"
    description="Every person on this page has matched one or more people in Team Engine on their email or phone number."
    PageIndicator={PageIndicator}
  />
);
